import React, { useState, useEffect } from 'react';
import styles from '../BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

let checkAll = false;
let hasFirstRender = false;
const BasicBrownfieldFilter = (props) => {
  const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
  const [checkAllCheckbox, setCheckAllCheckbox] = useState<Array<any>>([]);
  const options = {
    "Assessment Grants": {
      param: "BF_ASSESS_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "Assessment Pilots": {
      param: "BF_ASSESS_PILOT_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "Cleanup Grants": {
      param: "BF_CLEANUP_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "RLF Grants": {
      param: "BF_RLF_GRANT_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "RLF Pilots": {
      param: "BF_RLF_PILOT_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "Multi Purpose Grants": {
      param: "BF_MULTIPURPOSE_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "Area-Wide Planning Grants": {
      param: "BF_AWP_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "State and Tribal 128(a) Grants": {
      param: "BF_128A_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "State and Tribal 128(a) Pilots": {
      param: "BF_128A_P_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "Showcase Community": {
      param: "BF_SHOWCASE_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    },
    "Ready for Anticipated Use": {
      param: "BF_READY_FOR_REUSE_IND = 'Y'",
      isIncluded: false,
      objectIds: null
    }
  };

  const toggleAll = () => {
    // switch checkAll
    checkAll = !checkAll;
    for (let option in options) {
      if (checkAll) {
        // set all isIncludeds to false so they can be set to true from buildCheckBoxDivs()
        options[option]["isIncluded"] = false;
      } else if (!checkAll) {
        // switch all isIncludeds to true so they can be switched back to false by toggleParam()
        options[option]["isIncluded"] = true;
        toggleParam(option);
      }
    }
    buildCheckboxDivs();
  }


  const toggleParam = async (key) => {
    options[key].isIncluded = !options[key].isIncluded;
    passUpdatedParams();
  }

  const passUpdatedParams = () => {
    let paramArray: Array<any> = [];
    for (let option in options) {
      if (options[option].isIncluded === true) {
        paramArray.push(options[option].param)
      }
    }
    props.updateBrownfieldParams(paramArray);
  }

  const buildCheckAllCheckboxDiv = () => {
    let checkAllDiv;
    if (!checkAll) {
      checkAllDiv =
        <div className={styles.SectionTitleDivs}>
          <CalciteCheckbox name={"toggleAllBrownfields"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
          <label className={styles.FilterSectionLabels}>Brownfield Properties</label>
        </div>;
    } else if (checkAll) {
      checkAllDiv =
        <div className={styles.SectionTitleDivs}>
          <CalciteCheckbox checked name={"toggleAllBrownfields"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
          <label className={styles.FilterSectionLabels}>Brownfield Properties</label>
        </div>;
    }
    setCheckAllCheckbox(checkAllDiv);
  }

  const buildCheckboxDivs = () => {
    let tempArr: Array<any> = [];
    if (!checkAll) {
      for (let key in options) {
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else if (checkAll) {
      for (let key in options) {
        toggleParam(key);
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    }
    setCheckboxDivArray(tempArr);
  }

  useEffect(() => { }, [checkboxDivArray, checkAllCheckbox]);

  // useEffect(() => {buildCheckboxDivs();}, [checkAll])


  useEffect(() => {
    if (props.checkAllBoxes === true) {
      checkAll = true;
    } else if (props.checkAllBoxes === false) {
      if (props.customRouteUsed && hasFirstRender === false) {
        checkAll = true;
        hasFirstRender = true;
        buildCheckAllCheckboxDiv();
        buildCheckboxDivs();
        props.updateDefinitionExpression();
        return;
      } else {
        checkAll = false;
      }
    }
    buildCheckAllCheckboxDiv();
    buildCheckboxDivs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signalAChange]);

  return (
    <div className={styles.Sections}>
      {checkAllCheckbox}
      <div className={styles.CheckboxSectionDivs}>
        {checkboxDivArray}
      </div>
    </div>
  );

}

export default BasicBrownfieldFilter;